<template>
	<div class="content_section">
		<h1 class="content_head">{{ $t('All Games') }}</h1>
		<div v-for="(games, genre) in categorizedGames" :key="genre">
			<!-- Genre Title -->
			<div class="content_title" :id="genre.replace(/\s+/g, '-')">
				<span>{{ $t(genre) }}</span>
			</div>

			<!-- Game Grid -->
			<section class="content_grid">
				<router-link
					v-for="game in games"
					:key="game._id"
					:to="{ name: 'GameDetails', params: { id: game._id } }"
					class="game_card_link"
				>
					<div class="game_card">
						<img
							:alt="game.name"
							class="card_img"
							decoding="async"
							height="250"
							loading="lazy"
							:src="game.banner_sm_url"
							width="250"
						/>
						<div class="card_title">{{ $t(game.name) }}</div>
					</div>
				</router-link>
			</section>
		</div>

		<!-- Back to Home Page -->
		<div class="others">
			<router-link to="/" class="others-button"> {{ $t('Back to Home') }} </router-link>
		</div>
	</div>
</template>

<script>
import gamesData from '@/assets/games.json';

export default {
	data() {
		return {
			games: gamesData,
		};
	},

	computed: {
		categorizedGames() {
			return this.games.reduce((acc, game) => {
				game.genres.forEach((genre) => {
					if (!acc[genre]) {
						acc[genre] = [];
					}
					acc[genre].push(game);
				});
				return acc;
			}, {});
		},
	},

	mounted() {
		this.scrollToSelectedGenre();
	},

	watch: {
		'$route.query.genre': function () {
			this.scrollToSelectedGenre();
		},
	},

	methods: {
		scrollToSelectedGenre() {
			const genre = this.$route.query.genre;
			if (genre) {
				this.$nextTick(() => {
					const element = document.getElementById(genre.replace(/\s+/g, '-'));
					if (element) {
						element.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				});
			}
		},
	},
};
</script>

<style>
@media (max-width: 1000px) {
	.content_section {
		margin: auto !important;
	}
}
</style>
